import { render, staticRenderFns } from "./Female.vue?vue&type=template&id=58f7561d&"
import script from "./Female.vue?vue&type=script&lang=js&"
export * from "./Female.vue?vue&type=script&lang=js&"
import style0 from "./Female.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports